/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateOtherPrintDefDto
 */
export interface CreateUpdateOtherPrintDefDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDefDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDefDto
     */
    reason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOtherPrintDefDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDefDto
     */
    pdfTemplateType?: CreateUpdateOtherPrintDefDtoPdfTemplateTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOtherPrintDefDto
     */
    mode?: CreateUpdateOtherPrintDefDtoModeEnum;
}


/**
 * @export
 */
export const CreateUpdateOtherPrintDefDtoPdfTemplateTypeEnum = {
    art_82_ust_1: 'art_82_ust_1',
    art_82_uprzywilejowany: 'art_82_uprzywilejowany',
    art_82_instruktor_egzaminator: 'art_82_instruktor_egzaminator',
    art_39_transport_drogowy: 'art_39_transport_drogowy',
    medycyna_pracy: 'medycyna_pracy',
    karta_badania_psychologicznego: 'karta_badania_psychologicznego',
    karta_broni: 'karta_broni',
    bron_orzeczenie_lekarskie: 'bron_orzeczenie_lekarskie',
    bron_orzeczenie_psychologiczne: 'bron_orzeczenie_psychologiczne',
    bron_karta_badania_psychologicznego: 'bron_karta_badania_psychologicznego',
    karta_badania_profilaktycznego: 'karta_badania_profilaktycznego',
    mp_orzeczenie_lekarskie_43: 'mp_orzeczenie_lekarskie_43',
    mp_orzeczenie_lekarskie_43_ang: 'mp_orzeczenie_lekarskie_43_ang',
    mp_orzeczenie_lekarskie_43_transport: 'mp_orzeczenie_lekarskie_43_transport',
    kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany: 'kierowca_orzeczenie_lekarskie_art_75_uprzywilejowany',
    kierowca_orzeczenie_lekarskie_art_75_reszta: 'kierowca_orzeczenie_lekarskie_art_75_reszta',
    mp_zaswiadczenie_lekarskie_student: 'mp_zaswiadczenie_lekarskie_student',
    orzeczenie_sanitarno_epidemiologiczne: 'orzeczenie_sanitarno_epidemiologiczne',
    karta_badania_kierowcy: 'karta_badania_kierowcy',
    konsultacja_neurologiczna: 'konsultacja_neurologiczna',
    konsultacja_laryngologiczna: 'konsultacja_laryngologiczna',
    konsultacja_okulistyczna: 'konsultacja_okulistyczna',
    konsultacja_psychiatryczna: 'konsultacja_psychiatryczna',
    karta_odpowiedzi: 'karta_odpowiedzi',
    karta_badania_sanitarno_epidemiologicznego: 'karta_badania_sanitarno_epidemiologicznego',
    zaswiadczenie_lekarskie_zdolnosci_do_pracy: 'zaswiadczenie_lekarskie_zdolnosci_do_pracy',
    zaswiadczenie_sportowe: 'zaswiadczenie_sportowe',
    karta_badania_sportowego: 'karta_badania_sportowego',
    orzeczenie_stan_zdrowia_lekarza: 'orzeczenie_stan_zdrowia_lekarza',
    zaswiadczenie_stan_zdrowia_pielegniarka: 'zaswiadczenie_stan_zdrowia_pielegniarka',
    zaswiadczenie_stan_zdrowia_pielegniarka_art31: 'zaswiadczenie_stan_zdrowia_pielegniarka_art31',
    rejestrOrzeczen: 'rejestrOrzeczen',
    rejestrMedycynaPracy: 'rejestrMedycynaPracy',
    rejestrKierowcow: 'rejestrKierowcow',
    rejestrUczniowieStudenci: 'rejestrUczniowieStudenci',
    skierowanie_uczen: 'skierowanie_uczen',
    skierowanie_uczen_sanitarne: 'skierowanie_uczen_sanitarne',
    skierowanie_pracownik: 'skierowanie_pracownik',
    skierowanie_pracownik_sanitarne: 'skierowanie_pracownik_sanitarne',
    wynik_widzenia_zmierzchowego: 'wynik_widzenia_zmierzchowego',
    wybuch_cywilne_orzeczenie_lekarskie: 'wybuch_cywilne_orzeczenie_lekarskie',
    wybuch_cywilne_orzeczenie_psychologiczne: 'wybuch_cywilne_orzeczenie_psychologiczne',
    wybuch_wojsko_orzeczenie_lekarskie: 'wybuch_wojsko_orzeczenie_lekarskie',
    wybuch_wojsko_orzeczenie_psychologiczne: 'wybuch_wojsko_orzeczenie_psychologiczne',
    detektyw_orzeczenie_lekarskie: 'detektyw_orzeczenie_lekarskie',
    detektyw_orzeczenie_psychologiczne: 'detektyw_orzeczenie_psychologiczne',
    zestawienie_orzeczen: 'zestawienie_orzeczen',
    lista_firm: 'lista_firm',
    skierowanie_do_poradni: 'skierowanie_do_poradni',
    strazak_orzeczenie_lekarskie: 'strazak_orzeczenie_lekarskie',
    kierowca_rajdowy_orzeczenie_psychologiczne: 'kierowca_rajdowy_orzeczenie_psychologiczne',
    nauczyciel_poratowanie_zdrowia: 'nauczyciel_poratowanie_zdrowia',
    zaswiadczenie_okulary: 'zaswiadczenie_okulary',
    faktura_pl: 'faktura_pl',
    korekta_pl: 'korekta_pl'
} as const;
export type CreateUpdateOtherPrintDefDtoPdfTemplateTypeEnum = typeof CreateUpdateOtherPrintDefDtoPdfTemplateTypeEnum[keyof typeof CreateUpdateOtherPrintDefDtoPdfTemplateTypeEnum];

/**
 * @export
 */
export const CreateUpdateOtherPrintDefDtoModeEnum = {
    Referral: 'Referral'
} as const;
export type CreateUpdateOtherPrintDefDtoModeEnum = typeof CreateUpdateOtherPrintDefDtoModeEnum[keyof typeof CreateUpdateOtherPrintDefDtoModeEnum];


/**
 * Check if a given object implements the CreateUpdateOtherPrintDefDto interface.
 */
export function instanceOfCreateUpdateOtherPrintDefDto(value: object): value is CreateUpdateOtherPrintDefDto {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function CreateUpdateOtherPrintDefDtoFromJSON(json: any): CreateUpdateOtherPrintDefDto {
    return CreateUpdateOtherPrintDefDtoFromJSONTyped(json, false);
}

export function CreateUpdateOtherPrintDefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateOtherPrintDefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'active': json['active'],
        'pdfTemplateType': json['pdfTemplateType'] == null ? undefined : json['pdfTemplateType'],
        'mode': json['mode'] == null ? undefined : json['mode'],
    };
}

export function CreateUpdateOtherPrintDefDtoToJSON(value?: CreateUpdateOtherPrintDefDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'reason': value['reason'],
        'active': value['active'],
        'pdfTemplateType': value['pdfTemplateType'],
        'mode': value['mode'],
    };
}

